export default __webpack_public_path__ + "static/media/mail.96ed9eec.svg";